/* global bz_app, Track, angular, UserAPI */
bz_app.directive('messageContractorButton', [
  function () {
    return {
      restrict: 'AE',
      link: function (scope, element, attrs) {
        element.click(function (e) {
          var platform = isMobile.check() ? 'mobile' : 'desktop'
          var data = {
            action: 'message contractor from permit clicked',
            platform: platform,
          }
          Track.send('Property Action', data)
        })
      },
    }
  },
])
